import React from "react";
import "./messages.scss";


export const ErrorMessage = ({message}) => (
    <div className="messageBox">
        <p className="error-box">{message}</p>
    </div>
    
)

export const SuccessMessage = ({message}) => (
    <div className="messageBox">
        <p className="success-box">{message}</p>
    </div>
)
